import { Box, Typography, Button, Snackbar, Alert } from '@mui/material';
import {
  Download as DownloadIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useLogs } from '../hooks';
import { StatsCards, LogFilters, StatsCharts, LogTable } from '../components';

export default function Logs() {
  const { t } = useTranslation();
  const {
    logs,
    stats,
    loading,
    statsLoading,
    error,
    success,
    totalCount,
    paginationModel,
    setPaginationModel,
    filters,
    activeFilters,
    setFilters,
    applyFilters,
    clearFilters,
    refresh,
    export: exportLogs,
    exporting,
    clearMessages,
  } = useLogs();

  const hasActiveFilters: boolean = !!(
    activeFilters.action ||
    activeFilters.startDate ||
    activeFilters.endDate ||
    activeFilters.ipAddress ||
    activeFilters.licenseKey
  );

  return (
    <Box>
      {/* 页面标题和操作按钮 */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography variant="h4">{t('logs.title')}</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={refresh}
            disabled={loading}
          >
            {t('logs.refresh')}
          </Button>
          <Button
            variant="contained"
            startIcon={<DownloadIcon />}
            onClick={exportLogs}
            disabled={exporting || logs.length === 0}
          >
            {exporting ? t('logs.exporting') : t('logs.export')}
          </Button>
        </Box>
      </Box>

      {/* 统计卡片 */}
      <StatsCards
        stats={stats}
        loading={statsLoading}
        totalCount={totalCount}
        hasActiveFilters={hasActiveFilters}
      />

      {/* 过滤器 */}
      <LogFilters
        filters={filters}
        onChange={setFilters}
        onApply={applyFilters}
        onClear={clearFilters}
      />

      {/* 统计图表 */}
      {stats && !statsLoading && (
        <StatsCharts
          dailyActivations={stats.dailyActivations}
          actionDistribution={stats.actionDistribution}
          activeDevices={stats.activeDevices}
          licenseKeyStats={stats.licenseKeyStats}
        />
      )}

      {/* 日志表格 */}
      <LogTable
        logs={logs}
        loading={loading}
        totalCount={totalCount}
        paginationModel={paginationModel}
        onPaginationChange={setPaginationModel}
      />

      {/* 成功提示 */}
      <Snackbar
        open={!!success}
        autoHideDuration={3000}
        onClose={clearMessages}
      >
        <Alert
          onClose={clearMessages}
          severity="success"
          sx={{ width: '100%' }}
        >
          {success}
        </Alert>
      </Snackbar>

      {/* 错误提示 */}
      <Snackbar
        open={!!error}
        autoHideDuration={5000}
        onClose={clearMessages}
      >
        <Alert
          onClose={clearMessages}
          severity="error"
          sx={{ width: '100%' }}
        >
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
}
